import { fetchOrgUsers } from "./orgUsers";
import { notifyCoachEmail } from "./notifyCoach";

const fallbackTo = "xxdevelopments@gmail.com";

export async function notifySupportForOrg(user, orgId, payload = {}) {
  let emails = [];
  try {
    const orgUsers = await fetchOrgUsers(user, orgId);
    emails = orgUsers
      .filter((u) => String(u.role || "").toLowerCase().includes("superadmin"))
      .map((u) => u.email)
      .filter(Boolean);
  } catch {}
  if (!emails.length) emails = [fallbackTo];
  emails = Array.from(
    new Set(emails.map((email) => String(email || "").trim().toLowerCase()).filter(Boolean))
  );
  await notifyCoachEmail({
    to: emails,
    subject: payload.subject || "New support request",
    message: payload.message || "A new support request was submitted.",
  });
}

export async function notifySupportRecipient(to, payload = {}) {
  if (!to) return;
  await notifyCoachEmail({
    to,
    subject: payload.subject || "Support update",
    message: payload.message || "Your support request has been updated.",
  });
}
